import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        this.isReversed = (typeof this.getData('reversed') == 'string');
        this.hasLimit = (typeof this.getData('limit') == 'string');
        this.velocityOffset = (typeof this.getData('velocity') == 'string') ? parseFloat(this.getData('velocity')) : 1;
    }

    trigger(e) {
        if(e.mode == 'enter') {
            this.capartenY();
        } else {
            cancelAnimationFrame(this.raf);
        }
    }

    capartenY() {
        this.raf = requestAnimationFrame(() => this.capartenY());

        let velocity = this.velocityOffset * window.scrollInstance.velocity;

        if(window.isMobile) {
            velocity *= 0.2;
        }

        if(!this.isReversed) {
            if(this.hasLimit) {
                this.el.style.transform = `rotate(${Math.max(velocity, 0)}deg)`;
            } else {
                this.el.style.transform = `rotate(${velocity}deg)`;
            }
        } else {
            if(this.hasLimit) {
                this.el.style.transform = `rotate(${Math.min(0,-velocity)}deg)`
            } else {
                this.el.style.transform = `rotate(${-velocity}deg)`
            }
        }
    }

    destroy() {
        cancelAnimationFrame(this.raf);
    }
}
